import { render, staticRenderFns } from "./MemoView.vue?vue&type=template&id=fa13ddc4&scoped=true&"
import script from "./MemoView.vue?vue&type=script&lang=js&"
export * from "./MemoView.vue?vue&type=script&lang=js&"
import style0 from "./MemoView.vue?vue&type=style&index=0&id=fa13ddc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa13ddc4",
  null
  
)

export default component.exports